module.exports = __webpack_public_path__ + "static/img/lun_11.b456f87.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lun_11.jpg
// module id = /RVK
// module chunks = 1